<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaigns</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{vm.campaigns.length}} campaigns.
    </ion-list-header>
    
    <ion-list class="ion-text-wrap">
        @for (campaign of vm.campaigns; track $index) {
  <ion-item [disabled]=vb.disabled>
            <ion-grid>
                <ion-row>
                    <ion-col size="6">{{campaign.sentDate | myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</ion-col>
                    <ion-col size="6">Number of Recipients: {{campaign.numRecipients}}</ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
}
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled (click)="onAddCampaignClick()" title="Add" data-test="addCampaign">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>